import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { trackUserInteraction } from '../services/analytics';

interface QrCodePanelProps {
  appLink: string;
  primaryColor?: string;
}

const QrCodePanel: React.FC<QrCodePanelProps> = ({ appLink, primaryColor = '#111' }) => {
  // Track QR code link clicks
  const handleLinkClick = () => {
    trackUserInteraction('UI:QR Code Link Click', {
      url: appLink.split('?')[0]
    });
  };

  return (
    <div className="flex flex-col items-center">
      <QRCodeSVG
        value={appLink}
        size={120}
        fgColor={primaryColor}
        bgColor="transparent"
        className="rounded-lg border border-border"
        onClick={() => trackUserInteraction('UI:QR Code Image Click', { url: appLink.split('?')[0] })}
      />
      <p className="text-xs mt-2 text-center text-foreground-muted">Scan to open our app</p>
      {/* Show base URL as hyperlink, link to full appLink */}
      <a
        href={appLink}
        target="_blank"
        rel="noopener noreferrer"
        className="text-xs mt-1 text-primary underline break-all"
        onClick={handleLinkClick}
      >
        {appLink.split('?')[0]}
      </a>
    </div>
  );
};

export default QrCodePanel;
